module.exports = __webpack_public_path__ + "img/logout-copy-2.1719232f.svg";